export default function convertDateToCustomFormat(
    dateString,
    dateFormat = "MDY"
) {
    const date = new Date(dateString);
    const hours = date.getHours();

    const elements = {
        Y: date.getFullYear(),
        M: date.getMonth() + 1,
        D: date.getDate()
    };

    const formattedDate = `${elements[dateFormat[0]]}/${
        elements[dateFormat[1]]
    }/${elements[dateFormat[2]]} `;
    const formattedTime = hours % 12 || 12; // Convert 0 to 12 for midnight
    const amPm = hours < 12 ? "A.M" : "P.M";

    return `${formattedDate} ${formattedTime} ${amPm}`;
}



// WEBPACK FOOTER //
// ./src/services/dateFormatter.js